// Serientermine Tauschbörse + Notify-Kanal (Fallback)
export default {
  "winterdoppel.join.phoneHint":
    "Für WhatsApp-Benachrichtigungen (Tausch / Platz frei) bitte Handynummer angeben.",
  "winterdoppel.join.notifyChannel": "Nachricht bei Tausch / Platz frei",
  "winterdoppel.join.notifyChannel.mail": "E-Mail",
  "winterdoppel.join.notifyChannel.whatsapp": "WhatsApp",
  "winterdoppel.join.notifyChannel.both": "E-Mail und WhatsApp",
  "winterdoppel.join.notifyChannelHint":
    "Persönlicher Link. WhatsApp braucht eine hinterlegte Handynummer.",
  "winterdoppel.swap.offerAction": "Tausch anbieten",
  "winterdoppel.swap.panelTitle": "Tausch für {date}",
  "winterdoppel.swap.panelLead":
    "Wähle bis zu drei Gegentermine oder biete nur den Platz (Warteliste) an. Andere Familien der Serie erhalten eine Nachricht mit Antwort-Link.",
  "winterdoppel.swap.noPreferred":
    "Keine weiteren Termine zur Auswahl – du kannst den Platz freigeben.",
  "winterdoppel.swap.submitSwap": "Tausch anbieten",
  "winterdoppel.swap.submitWaitlist": "Nur Platz freigeben",
  "winterdoppel.swap.offerSaved":
    "Tauschbörse gestartet. {count} Familien wurden benachrichtigt.",
  "winterdoppel.swap.offerSavedNotifyFailed":
    "Angebot gespeichert, Benachrichtigung fehlgeschlagen: {detail}",
  "winterdoppel.swap.acceptTitle": "Tauschbörse",
  "winterdoppel.swap.acceptLead":
    "{name} kann am {date} nicht ({series}). Möchtest du tauschen oder den Platz übernehmen?",
  "winterdoppel.swap.choosePreferred": "Gegentermin wählen:",
  "winterdoppel.swap.takeSpot":
    "Du übernimmst den freien Platz an diesem Termin.",
  "winterdoppel.swap.accept": "Annehmen",
  "winterdoppel.swap.decline": "Ablehnen",
  "winterdoppel.swap.accepted": "Tausch angenommen. Danke!",
  "winterdoppel.swap.declined": "Du hast abgelehnt.",
  "winterdoppel.swap.offerClosed": "Dieses Angebot ist nicht mehr offen.",
  "winterdoppel.swap.loadError": "Angebot konnte nicht geladen werden.",
  "winterdoppel.swap.loading": "Laden …",
};
